module.exports = __webpack_public_path__ + "static/img/season-dia-bubble-alert-pc.a91f7bd.png";